<template>
  <div class="footer">
    <div class="version">
      <a href="javascript:;" style="margin-right: 20px">{{ $Cfg.siteName }}</a>
      <b>Version</b> {{ $Cfg.version }}
    </div>
    <strong>Copyright © 2019 远健卓实教育科技（北京）有限公司.</strong> All rights reserved. 京ICP备19042936号-2
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    methods: {}
  }
</script>
<style lang="scss">
  .footer {
    width: 100%;
    font-size: 14px;
    background: #fff;
    line-height: 50px;
    padding: 0 12px;
    height: 50px;
    color: #444;
    border-top: 1px solid #d2d6de;
    .version {
      float: right;
      b {
        font-weight: 700;
      }
      .github{
        color: #444;
        font-size: 20px;
        margin-left: 8px;
        &:hover{
          color: #8BC34A;
        }
      }
    }
  }
</style>
